<script lang="ts" setup>
// import { useI18n } from 'vue-i18n';
// import Cookies from 'js-cookie';
// import { COOKIE_KEY_LANGUAGE, ROUTER_BASE_URL } from '@/summit/2023/constants';
// import { useAppStore } from '@/summit/2023/stores/app';

defineOptions({
  name: 'PageHeader',
});

// const store = useAppStore();
// const { locale } = useI18n();

// const changeLanguage = (lang: string) => {
//   Cookies.set(COOKIE_KEY_LANGUAGE, lang, { expires: 3650, path: '/' });
//   window.location.href = `${ROUTER_BASE_URL}/`;
// }
</script>

<template>
  <header class="page-header absolute left-0 right-0 top-0 z-60 h-72px bg-[rgba(255,255,255,0.4)] hover:bg-[rgba(255,255,255,0.8)]">
    <div class="page-header__container mx-88px h-full flex items-center text-16px color-hex-2d2d2d">
      <div class="h-56px w-400px">
        <img src="@/summit/2023/assets/common/logo.png" alt="LOGO" class="block h-full w-full object-contain">
      </div>

      <nav class="flex flex-grow items-center">
        <ul class="m-0 flex list-none p-0 children:ml-31px hover:children:color-hex-00479D">
          <li>
            <RouterLink to="/" class="block no-underline">首页</RouterLink>
          </li>
          <li>
            <a href="https://openatom.org" target="_blank" class="block no-underline">开放原子开源基金会</a>
          </li>
          <li>
            <a href="/summit/2023/index/manual" target="_blank" class="block no-underline">2023 峰会会议手册</a>
          </li>
        </ul>

        <div class="ml-31px">
          <a href="https://openatom.tech/OpenAtomFoundation/event_resources/tree/master/2023OAGS" target="_blank" class="sign-up block min-w-198px rounded-40px px-35px text-center color-white leading-40px no-underline">
            精彩演讲内容合集
          </a>
        </div>
      </nav>

      <!-- <div class="flex items-center">
        <div>
          <a href="javascript:;" class="hover:color-hex-00479D" :class="{ 'color-hex-00479D': locale === 'zh' }" @click="changeLanguage('zh')">中文</a>
          /
          <a href="javascript:;" class="hover:color-hex-00479D" :class="{ 'color-hex-00479D': locale === 'en' }" @click="changeLanguage('en')">English</a>
        </div>
      </div> -->
    </div>
  </header>
</template>

<style lang="scss" scoped>
.page-header {
  .sign-up {
    background: linear-gradient(270deg, rgba(128, 196, 141, 1), rgba(34, 140, 205, 1) 100%);

    &.disabled {
      background: #c1c3c7;
      cursor: not-allowed;
    }

    &:hover:not(.disabled) {
      background: linear-gradient(270deg, rgba(162, 247, 178, 1), rgba(42, 174, 255, 1) 100%);
    }
  }
}
</style>
